/**
 * Filter-Chip-Stile (SSOT) — Redesign S2 Phase 2a (2026-10-10,
 * `tasks/design-handoff-redesign-s2.md` § Phase 2 + § Regeln).
 *
 * - Inaktiv: weiß + `border-ink-200` (Sekundär-Regel), Label + Chevron.
 * - Aktiv: `bg-brand-green-700` + weißer Text (Kontrast 8,8 : 1, AA) mit
 *   Anzahl-Badge (weiß auf grün invertiert, gleiches Paar) + eigenem ×-Button.
 * - Radius `rounded-control` (10px, Controls). Kein Gelb (gehört dem
 *   Hochladen-CTA). Mobile (< md) 44px hoch (Touch-Ziel), ab md 36px.
 *
 * Der aktive Chip ist zweiteilig (Trigger + ×) — beide tragen die halbe
 * Rundung, die Trennlinie ist ein heller linker Rand am ×.
 */
const BASE =
  'inline-flex items-center gap-1.5 h-11 md:h-9 px-3.5 border text-xs font-semibold whitespace-nowrap transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-700 focus-visible:ring-offset-2';

export const FILTER_CHIP_INACTIVE = `${BASE} rounded-control bg-white border-ink-200 text-brand-green-800 hover:border-brand-green-700/40`;

/** Aktiver Chip-Trigger (links), gefolgt von `FILTER_CHIP_CLEAR`. */
export const FILTER_CHIP_ACTIVE = `${BASE} rounded-l-control bg-brand-green-700 border-brand-green-700 text-white hover:bg-brand-green-800`;

/** Nicht-interaktives Label eines aktiven Chips (Suche, Ohne Tags …). */
export const FILTER_CHIP_ACTIVE_LABEL =
  'inline-flex items-center h-11 md:h-9 pl-3.5 pr-2.5 rounded-l-control border border-brand-green-700 bg-brand-green-700 text-white text-xs font-semibold whitespace-nowrap max-w-[16rem]';

export const FILTER_CHIP_CLEAR =
  'inline-flex items-center justify-center h-11 w-11 md:h-9 md:w-8 shrink-0 rounded-r-control border border-brand-green-700 border-l-white/30 bg-brand-green-700 text-white hover:bg-brand-green-800 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-700 focus-visible:ring-offset-2';

export const FILTER_CHIP_COUNT =
  'inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-white text-brand-green-700 text-xs font-bold tabular-nums';
